<template>
  <ux-form
    class="upgrade"
    ref="form"
    width="500px"
    :data="formData"
    :colon="true"
    :rules="rules"
    label-width="56px"
    data-automation="upgrade"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.upgrade.mctype')" required prop="jixiang">
      <ux-select v-model="formData.jixiang" clearable :options="[]"></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.upgrade.appType')" required prop="yingyongleixing">
      <ux-input
        v-model="formData.yingyongleixing"
        :maxlength="50"
        :placeholder="$t('HT.upgrade.appType.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item
      :label="$t('HT.upgrade.type')"
      required
      prop="leixing"
      v-for="(item, index) in formData.list"
      :key="item"
    >
      <ux-select
        class="select-type"
        v-model="formData.list[index].leixing"
        clearable
        :options="[]"
      ></ux-select>
      <ux-form-item
        :label="$t('HT.upgrade.versions')"
        required
        label-width="56px"
        prop="banben"
        bottom="0px"
      >
        <ux-select
          class="select-type"
          v-model="formData.list[index].banben"
          clearable
          :options="[]"
        ></ux-select>
      </ux-form-item>
      <ux-button class="x-margin-l" v-if="formData.list.length === 1" type="primary" @click="add">{{
        $t('HT.add')
      }}</ux-button>
      <ux-button class="x-margin-l" v-else type="primary" @click="del(index)">{{
        $t('HT.delete')
      }}</ux-button>
    </ux-form-item>

    <ux-form-item :label="$t('HT.startTime')" required prop="date">
      <ux-date v-model="formData.date" daterange time></ux-date>
    </ux-form-item>

    <ux-form-item
      :label="$t('HT.upgrade.upgradePeriod')"
      start
      required
      prop="shengjishiduan"
      :tip="$t('HT.upgrade.upgradePeriod.tip')"
    >
      <span slot="tip" class="x-red-text x-margin-t">{{ $t('HT.upgrade.upgradePeriod.tip') }}</span>
      <ux-select v-model="formData.shengjishiduan" clearable :options="[]"></ux-select>
    </ux-form-item>

    <ux-form-item :label="$t('HT.upgrade.remark')" start required prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>

    <ux-form-item :label="$t('HT.devicesList')" required start prop="device">
      <ux-input v-model="formData.device" type="textarea"></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          jixiang: '',
          yingyongleixing: '',
          leixing: '',
          banben: '',
          start_time: '',
          end_time: '',
          date: [],
          shengjishiduan: '',
          list: [{}],
          device: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addGroup()
    };
  },

  methods: {
    add() {
      this.formData.list.push({
        leixing: '',
        banebn: ''
      });
    },

    del(index) {
      this.formData.list.splice(index, 1);
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$emit('confirm', this.formData);
    }
  }
};
</script>
